// Contact-detail validation shared by the group date and location forms. Each helper
// returns an error message, or null when valid.
//
// A blank value returns `requiredMessage`, so pass one where the field is mandatory and
// omit it where blank is allowed. The format check only runs on a non-empty value.
//
// Plain functions, not vee-validate rules: that's only wired up on the auth pages, and it
// ships no phone rule.

// Mirrors vee-validate's email rule: one @, no whitespace, dotted TLD.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/

// Stripped before counting digits.
const PHONE_SEPARATORS = /[\s\-().]/g

// E.164: country code 1-9, then 7-14 digits.
const PHONE_RE = /^\+[1-9]\d{7,14}$/

const LINK_HINT = 'Enter a full link starting with https://, for example https://yourrestaurant.com.'

export const emailError = (value, { requiredMessage = null } = {}) => {
  const email = (value || '').trim()
  if (!email) return requiredMessage
  if (!EMAIL_RE.test(email)) return 'That doesn’t look like a valid email address.'
  return null
}

export const phoneError = (value, { requiredMessage = null } = {}) => {
  const phone = (value || '').trim()
  if (!phone) return requiredMessage
  const compact = phone.replace(PHONE_SEPARATORS, '')
  if (/[^+\d]/.test(compact)) return 'Enter the number in international format, for example +31 6 12345678.'
  if (!compact.startsWith('+')) return 'Include the country code, for example +44 7700 900123.'
  if (!PHONE_RE.test(compact)) return 'That doesn’t look like a valid phone number.'
  return null
}

export const linkError = (value, { requiredMessage = null } = {}) => {
  const link = (value || '').trim()
  if (!link) return requiredMessage
  let url
  try {
    url = new URL(link)
  } catch (e) {
    return LINK_HINT
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return LINK_HINT
  // Rejects "https://localhost" and "https://book".
  if (!/^[^\s.]+(\.[^\s.]+)+$/.test(url.hostname)) return 'That link’s web address doesn’t look complete.'
  return null
}
